export default "__VITE_ASSET__Ddi8Oco7__"